import * as actionTypes from "./actionTypes";
import store from "../store";
import { getEntrySummaryForm } from "../api/getEntrySummaryData";

import { initializeCFIA, initializeECCCFlag } from "./initializeValues";
import { getInitialCFIA } from "../components/entrySummaryForms/util/initialValues";
export const toggleCFIA = (
  merchandiseId,
  loading,
  lineItemIndex,
  pgaPayload
) => ({
  type: actionTypes.TOGGLE_CFIA(lineItemIndex),
  payload: {
    merchandiseId,
    loading,
    lineItemIndex,
    pgaPayload,
  },
});
export function toggleCFIAForm(merchandiseId, lineItemIndex, pgaPayload) {
  store.dispatch(toggleCFIA(merchandiseId, true, lineItemIndex, pgaPayload));
  getEntrySummaryForm(window.shipmentId)
    .then((response) => {
      store.dispatch(
        initializeECCCFlag(
          response.data.eventMessage.descriptionOfMerchandise
            .merchandiseLineItems
        )
      );
      const responseData =
        response.data.eventMessage?.descriptionOfMerchandise
          ?.merchandiseLineItems[lineItemIndex]?.pgaDetails?.pgaDetails;
      const initialData = getInitialCFIA();

      if (responseData) {
        for (let i = 0; i < responseData.length; i++) {
          if (responseData[i].pga.cbsaPgaType === "CFIA") {
            return store.dispatch(
              initializeCFIA(lineItemIndex, responseData[i])
            );
          }
        }
        return store.dispatch(initializeCFIA(lineItemIndex, initialData));
      } else {
        return store.dispatch(initializeCFIA(lineItemIndex, initialData));
      }
    })

    .catch((err) => {
      console.error("CFIA Error", err);
      let error = {
        CFIAError: err,
      };
      return store.dispatch(
        initializeCFIA(lineItemIndex, {
          error: `ERROR: Could not retrieve CFIA Certification for the associated HTS and Merchandise ID ${merchandiseId} ${error}`,
        })
      );
    });
}

export function updateCFIAField(lineItemIndex, field, payload) {
  return {
    type: actionTypes.UPDATE_CFIA_FIELD(lineItemIndex),
    payload,
    field,
  };
}

export function saveCFIAField(merchandiseId, lineItemIndex, field, level) {
  return {
    type: actionTypes.SAVE_CFIA_FIELD(lineItemIndex),
    field,
    merchandiseId,
    level,
  };
}
